module.exports = __webpack_public_path__ + "static/img/luntan.55ff5ab7.png";